<template>
  <div
    class="w-100 h-100 d-flex flex-column align-items-center justify-content-center"
  >
    <img
      alt="brand image"
      src="../../assets/images/clohea-logo.png"
      class="brand-loader"
    />
    <span class="loading-text" v-if="loadingText !== ''">
      {{ loadingText }}
    </span>
  </div>
</template>

<script>
export default {
  name: "BrandLoader",
  props: {
    loadingText: {
      type: String,
      default: "Loading..."
    }
  }
};
</script>

<style scoped>
.brand-loader {
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);
  opacity: 0.4;
  -webkit-filter: grayscale(50%);
  filter: grayscale(50%);
  -webkit-animation: pulse-black 1s infinite;
  animation: pulse-black 1s infinite;
  width: 3.5rem;
}

.loading-text {
  font-size: var(--font-xs);
  color: var(--ch-dark-gray);
  opacity: 0.6;
}

@media screen and (min-width: 992px) {
  .brand-loader {
    width: 4rem;
  }

  .loading-text {
    font-size: var(--font-sm);
  }
}

@-webkit-keyframes pulse-black {
  0% {
    -webkit-transform: scale(0.96);
    transform: scale(0.96);
    -webkit-filter: grayscale(50%);
    filter: grayscale(50%);
  }

  70% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-filter: grayscale(10%);
    filter: grayscale(10%);
  }

  100% {
    -webkit-transform: scale(0.96);
    transform: scale(0.96);
    -webkit-filter: grayscale(50%);
    filter: grayscale(50%);
  }
}

@keyframes pulse-black {
  0% {
    -webkit-transform: scale(0.96);
    transform: scale(0.96);
    -webkit-filter: grayscale(50%);
    filter: grayscale(50%);
  }

  70% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-filter: grayscale(10%);
    filter: grayscale(10%);
  }

  100% {
    -webkit-transform: scale(0.96);
    transform: scale(0.96);
    -webkit-filter: grayscale(50%);
    filter: grayscale(50%);
  }
}
</style>
